import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "collapse",
            name: "All Template",
            key: "all",
            icon: <Icon fontSize="medium">settings_system_daydream</Icon>,
            privacy: "private",
            collapse: [
                {
                    type: "menu_item",
                    name: "Contacts",
                    key: "contacts",
                    route: "/all/contacts",
                    privacy: "private",
                },
                {
                    type: "menu_item",
                    name: "Users",
                    key: "users",
                    route: "/all/users",
                    privacy: "private",
                },
                {
                    type: "menu_item",
                    name: "Standard Api",
                    key: "standard-api",
                    route: "/all/standard-api",
                    privacy: "private",
                },
                {
                    type: "menu_item",
                    name: "Internal Api",
                    key: "internal-api",
                    route: "/all/internal-api",
                    privacy: "private",
                },
                {
                    type: "menu_item",
                    name: "Streaming",
                    key: "streaming",
                    route: "/all/streaming",
                    privacy: "private",
                },
                {
                    type: "menu_item",
                    name: "Attachments",
                    key: "attachments",
                    route: "/all/attachments",
                    privacy: "private",
                },
                {
                    type: "menu_item",
                    name: "Content Version",
                    key: "content-version",
                    route: "/all/content-version",
                    privacy: "private",
                },
                {
                    type: "menu_item",
                    name: "Sobject Api",
                    key: "sobject-api",
                    route: "/all/sobject-api",
                    privacy: "private",
                },
                {
                    type: "menu_item",
                    name: "UI Api",
                    key: "uiapi",
                    route: "/all/uiapi",
                    privacy: "private",
                },
                {
                    type: "menu_item",
                    name: "Jsforce",
                    key: "jsforce",
                    route: "/all/jsforce",
                    privacy: "private",
                },
                {
                    type: "menu_item",
                    name: "Pdf Viewer",
                    key: "pdf",
                    route: "/all/pdf",
                    privacy: "private",
                },
            ]
        },
    ];
};

export default menus;